import { FormikActions } from "formik";
import { array, object, string } from "yup";

const FIELD_FOLDER_ID = "folderId";
const FIELD_FILES = "files";

const INITIAL_VALUES = {
  [FIELD_FOLDER_ID]: "",
  [FIELD_FILES]: [],
};

const validationSchema = object({
  [FIELD_FOLDER_ID]: string().required("Folder Id is required."),
  [FIELD_FILES]: array().min(1, "Files is empty."),
});

export type ValueTypes = typeof INITIAL_VALUES;

export type FormActionTypes = FormikActions<ValueTypes>;

export {
  FIELD_FILES,
  FIELD_FOLDER_ID,
  INITIAL_VALUES,
  validationSchema,
};
